import React from 'react';
import Course from './Course';

export default React.createClass({
    propTypes: {
        data: React.PropTypes.array,
        onRemove: React.PropTypes.func,
        urls: React.PropTypes.object,
        i18n: React.PropTypes.object,
        leadingCoursesUrl: React.PropTypes.string,
        courseDetailsUrl: React.PropTypes.string
    },
    render() {
        if (!this.props.data || !this.props.data.length) {
            return (
                <div className="c-courses__course">
                    {this.props.i18n.noOtherCourses}
                </div>
            )
        } else {
            return (
                <div>
                    {this.props.data.map((model, idx) => {
                        return <Course
                            key={model.Id}
                            id={model.Id}
                            courseNumber={model.CourseNumber}
                            name={model.Name}
                            lastPlayed={model.LastPlayed}
                            onRemove={this.props.onRemove}
                            i18n={this.props.i18n}
                            urls={this.props.urls}
                            leadingCoursesUrl={this.props.leadingCoursesUrl}
                            leadingCoursesId={model.LeadingCoursesId}
                            courseDetailsUrl={this.props.courseDetailsUrl}
                        />;
                    })}
                </div>
            );
        }
    }
});
